<script setup>
import { defineEmits, defineProps } from 'vue'
import BaseCard from "@/pages/UserProfile/integrations/BaseCard.vue";
import StatusBadge from "@/pages/UserProfile/components/StatusBadge.vue";

defineProps({
    transactions: Array
});

const emit = defineEmits(['open-payment-history']);
</script>

<template>
    <BaseCard>
        <template #header>
            <h3 class="font-medium text-gray-900 text-base">История платежей</h3>
            <button
                type="button"
                class="text-blue-600 text-sm hover:underline font-medium"
                @click="emit('open-payment-history')"
            >
                Все
            </button>
        </template>
        <div v-if="transactions.length" class="space-y-5">
            <div v-for="tx in transactions" :key="tx.id" class="flex justify-between items-center">
                <div class="flex flex-col">
                    <div class="flex items-center gap-2">
                        <span class="text-sm font-medium text-gray-800">{{ tx.date }}</span>
                        <span class="text-xs text-gray-400">•</span>
                        <StatusBadge :status="tx.status" />
                    </div>
                </div>

                <div class="flex items-center gap-3">
                    <span class="text-sm font-medium text-gray-900">{{ tx.amount }}</span>
                </div>
            </div>
        </div>
        <p v-else class="text-sm text-gray-500">
            Платежей пока нет
        </p>
    </BaseCard>
</template>